import { serviceSendForgotPassword } from '../../graphql/queries';
import { executeGql, processGqlResult } from '../../utils/gql-utils';

export const getServiceSendForgotPassword = async (
  email: string,
  fromVenueWeb: boolean,
): Promise<boolean> => {
  const result = await executeGql(serviceSendForgotPassword, { email, fromVenueWeb }, 'iam');
  return processGqlResult<boolean>('data.serviceSendForgotPassword', result);
};
